import { RootState } from "../../rootReducers";
import { LanguageEnum } from "./appTypes";

export const selectToastMessage = (state: RootState) => state.app.toastMessage;

export const selectLanguage = (state: RootState) =>
  state.app.language || LanguageEnum.EN;

export const selectSidebarCollapsed = (state: RootState) =>
  state.app.sidebarCollapsed ?? false;

export const selectSimulatedRole = (state: RootState) =>
  state.app.simulatedRole ?? null;
